import { createReducer } from 'typesafe-actions';

import { ICursorElements } from '@/store/types/search.types';

import { ICardTransaction } from '@/features/cards/store/models/card.model';

import {
  TCardTransactionAction,
  CardTransactionActionTypes,
  ICardTransactionState,
} from '@/store/types/card-transactions.type';

const initialState: ICardTransactionState = {
  paginateCardTransactions: {} as ICursorElements<ICardTransaction>,
  isLoading: false,
};

export const cardTransactionsReducer = createReducer<ICardTransactionState, TCardTransactionAction>(initialState)
  .handleType(CardTransactionActionTypes.GET_CARD_TRANSACTIONS, (state) => ({
    ...state,
    error: undefined,
    isLoading: true,
  }))

  .handleType(CardTransactionActionTypes.GET_CARD_TRANSACTIONS_SUCCESS, (state, action) => {
    return {
      ...state,
      paginateCardTransactions: action.paginateCardTransactions,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(CardTransactionActionTypes.GET_CARD_TRANSACTIONS_FAIL, (state, action) => {
    return {
      ...state,
      error: action.error,
      isLoading: false,
    };
  });
